import './App.css';
import Hero from './components/Hero/Hero';
import Plans from './components/Plans/plans';
import Programs from './components/Programs/programs';
import Reasons from './components/Reasons/reasons';
import Testimonials from '../src/components/Testimonials/testemonial';
import Join from './components/Join/join';
import Footer from './components/Footer/footer';


function App() {
  return (
    <div className="App">
      <Hero />
      <Programs />
      <Reasons />
      <Plans />
      <Testimonials />
      <Join />
      <Footer />
    </div>
  );
}

export default App;
